import axios from 'axios';
import DirectoryService from './DirectoryService';
import { string } from 'is_js';

const SettingsService = {
  async retrieveSettings() {
    const { accountIdentifier } = DirectoryService.retrieveLoggedProfile();
    try {
      const response = await fetch('/api/settings/' + accountIdentifier);
      
      if (response.ok) {
        const data = await response.json();
        console.log('Settings retrieved:', data);
        return data;
      }
    } catch (error) {
      console.error('Error fetching user', error);
      throw error;
    }
  },
  async retrieveDefaultCurrency() {
    const { accountIdentifier } = DirectoryService.retrieveLoggedProfile();
    try {
      const response = await fetch('/api/settings/' + accountIdentifier);
      
      if (response.ok) {
        const data = await response.json();
        console.log('Default currency retrieved:', data);

        return data.currency || 'gbp';
      }
    } catch (error) {
      console.error('Error fetching default currency', error);
      throw error;
    }
  },
  async saveSettings(formData) {
    const profileLogged = JSON.parse(localStorage.getItem('profile'));
    const { accountIdentifier } = profileLogged;
    const logo = formData.logo;
    console.log('Logo Settings', formData.logo);
    console.log('Logo format string',  logo instanceof string);
    if (logo === undefined || typeof logo === "string") {
      console.log('Sarasa Sarasa');
      try {
        let url = '/api/settings';
        let method = 'PUT';

        if (formData.identifier === undefined) {
          url = '/api/settings';
          method = 'POST';
          formData.identifier = accountIdentifier;
        } else {
          url += '/' + accountIdentifier;
        }

        const response = await fetch(url, {
          method: method,
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });
        if (response.ok) {
          const newSettings = await response.json();
          console.log('Settings has been updated:', newSettings);
        }
      } catch (error) {
        console.log('Error saving Settings', error);
      }
    } else {
      const settings = { ...formData };
      delete settings.logo;

      if (settings.identifier === undefined) {
        settings.identifier = accountIdentifier;
      }

      const data = new FormData();
      console.log('Logo', logo);
      data.append('file', logo);
      data.append('fileName', logo.name);
      console.log('Settings', settings);
      data.append('settings', JSON.stringify(settings));
      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      };
      let url = '/api/settings/with-logo';
      try {
        if (formData.identifier !== undefined) {
          url = '/api/settings/' + accountIdentifier + '/with-logo';
          axios.put(url, data, config).then(response => {
            console.log('Settings has been updated:', response.data);
          });
        } else {
          axios.post(url, data, config).then(response => {
            console.log('Settings has been created:', response.data);
          });
        }
      } catch (error) {
        console.log('Error saving Settings', error);
      }
    }
  }
};

export default SettingsService;
